(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["art-canvas"] && !Shopify.designMode) return;
  try {
    

(function () {
  'use strict';

  function hexToRgb(hex) {
    var clean = hex.replace('#', '');
    if (clean.length === 3) {
      clean = clean.split('').map(function (c) { return c + c; }).join('');
    }
    var num = parseInt(clean, 16);
    return {
      r: (num >> 16) & 255,
      g: (num >> 8)  & 255,
      b:  num        & 255
    };
  }

  function initArtCanvas(section) {
    var canvas        = section.querySelector('.art-canvas__canvas');
    if (!canvas) return;
    var ctx           = canvas.getContext('2d');
    var particleColor = section.dataset.particleColor || '#6366f1';
    var particleCount = parseInt(section.dataset.particleCount, 10) || 60;
    var rgb           = hexToRgb(particleColor);
    var particles     = [];
    var mouse         = { x: -9999, y: -9999 };
    var rafId         = null;
    var resizeTimer   = null;
    var CONNECT_DIST  = 120;
    var ATTRACT_DIST  = 150;
    var ATTRACT_FORCE = 0.025;
    var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // ── Resize canvas ──────────────────────────────
    function resize() {
      canvas.width  = section.offsetWidth;
      canvas.height = section.offsetHeight;
    }

    // ── Create particles ───────────────────────────
    function createParticles() {
      particles = [];
      for (var i = 0; i < particleCount; i++) {
        particles.push({
          x:  Math.random() * canvas.width,
          y:  Math.random() * canvas.height,
          vx: (Math.random() - 0.5) * 0.6,
          vy: (Math.random() - 0.5) * 0.6,
          r:  Math.random() * 2 + 1.5
        });
      }
    }

    // ── Draw one frame ─────────────────────────────
    function draw() {
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      // Update positions (skip if reduced motion — static render)
      if (!prefersReducedMotion) {
        for (var i = 0; i < particles.length; i++) {
          var p = particles[i];

          // Mouse attraction
          var dx = mouse.x - p.x;
          var dy = mouse.y - p.y;
          var dist = Math.sqrt(dx * dx + dy * dy);
          if (dist < ATTRACT_DIST && dist > 0) {
            var force = (1 - dist / ATTRACT_DIST) * ATTRACT_FORCE;
            p.vx += (dx / dist) * force;
            p.vy += (dy / dist) * force;
          }

          // Speed cap
          var speed = Math.sqrt(p.vx * p.vx + p.vy * p.vy);
          if (speed > 1.8) {
            p.vx = (p.vx / speed) * 1.8;
            p.vy = (p.vy / speed) * 1.8;
          }

          p.x += p.vx;
          p.y += p.vy;

          // Wrap edges
          if (p.x < 0)             p.x = canvas.width;
          if (p.x > canvas.width)  p.x = 0;
          if (p.y < 0)             p.y = canvas.height;
          if (p.y > canvas.height) p.y = 0;
        }
      }

      // Draw connections
      for (var a = 0; a < particles.length; a++) {
        for (var b = a + 1; b < particles.length; b++) {
          var pa = particles[a];
          var pb = particles[b];
          var ddx = pa.x - pb.x;
          var ddy = pa.y - pb.y;
          var d   = Math.sqrt(ddx * ddx + ddy * ddy);
          if (d < CONNECT_DIST) {
            var alpha = (1 - d / CONNECT_DIST) * 0.45;
            ctx.beginPath();
            ctx.strokeStyle = 'rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ',' + alpha + ')';
            ctx.lineWidth = 1;
            ctx.moveTo(pa.x, pa.y);
            ctx.lineTo(pb.x, pb.y);
            ctx.stroke();
          }
        }
      }

      // Draw particles
      for (var j = 0; j < particles.length; j++) {
        var pt = particles[j];
        ctx.beginPath();
        ctx.fillStyle = 'rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ',0.85)';
        ctx.arc(pt.x, pt.y, pt.r, 0, Math.PI * 2);
        ctx.fill();
      }
    }

    // ── Animation loop ─────────────────────────────
    function loop() {
      draw();
      if (!prefersReducedMotion) {
        rafId = requestAnimationFrame(loop);
      }
    }

    // ── Resize (debounced) ─────────────────────────
    function onResize() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        resize();
        createParticles();
        if (prefersReducedMotion) draw();
      }, 180);
    }

    // ── Mouse tracking (window-level — bypasses z-index / pointer-events) ──
    function onMouseMove(e) {
      var rect  = section.getBoundingClientRect();
      mouse.x   = e.clientX - rect.left;
      mouse.y   = e.clientY - rect.top;
      // Reduced-motion: no loop running, so draw manually on each move
      if (prefersReducedMotion) draw();
    }

    // ── Boot ───────────────────────────────────────
    // Use rAF so layout is complete before we read offsetWidth/Height
    requestAnimationFrame(function () {
      resize();
      createParticles();
      if (prefersReducedMotion) {
        draw();
      } else {
        loop();
      }
    });

    window.addEventListener('mousemove', onMouseMove, { passive: true });
    window.addEventListener('resize',    onResize,    { passive: true });

    // ── Cleanup when section is unloaded in editor ─
    section.addEventListener('shopify:section:unload', function () {
      if (rafId) cancelAnimationFrame(rafId);
      window.removeEventListener('mousemove', onMouseMove);
      window.removeEventListener('resize',    onResize);
    });
  }

  // ── Init all instances ────────────────────────────
  function init() {
    document.querySelectorAll('.art-canvas').forEach(function (section) {
      initArtCanvas(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('.art-canvas');
    if (section) initArtCanvas(section);
  });

}());


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["before-after-slider"] && !Shopify.designMode) return;
  try {
    

(function () {
  'use strict';

  function initSlider(wrapper) {
    var sectionId = wrapper.dataset.baId;
    var handle    = document.getElementById('ba-handle-' + sectionId);
    var beforeLayer = wrapper.querySelector('.ba-layer--before');
    var hint      = wrapper.querySelector('.ba-hint');

    if (!handle || !beforeLayer) return;

    var pos       = 50;  // 0-100
    var dragging  = false;
    var hintHidden = false;

    function hideHint() {
      if (!hintHidden && hint) {
        hint.classList.add('is-hidden');
        hintHidden = true;
      }
    }

    function setPos(newPos) {
      pos = Math.max(0, Math.min(100, newPos));
      wrapper.style.setProperty('--ba-pos', pos + '%');
      handle.setAttribute('aria-valuenow', Math.round(pos));
      hideHint();
    }

    function posFromEvent(e) {
      var rect = wrapper.getBoundingClientRect();
      var clientX = e.touches ? e.touches[0].clientX : e.clientX;
      var ratio = (clientX - rect.left) / rect.width * 100;
      return ratio;
    }

    // Mouse events
    handle.addEventListener('mousedown', function (e) {
      e.preventDefault();
      dragging = true;
      wrapper.classList.add('is-dragging');
    });

    document.addEventListener('mousemove', function (e) {
      if (!dragging) return;
      setPos(posFromEvent(e));
    });

    document.addEventListener('mouseup', function () {
      if (!dragging) return;
      dragging = false;
      wrapper.classList.remove('is-dragging');
    });

    // Touch events
    handle.addEventListener('touchstart', function (e) {
      dragging = true;
      wrapper.classList.add('is-dragging');
    }, { passive: true });

    handle.addEventListener('touchmove', function (e) {
      if (!dragging) return;
      setPos(posFromEvent(e));
    }, { passive: true });

    handle.addEventListener('touchend', function () {
      dragging = false;
      wrapper.classList.remove('is-dragging');
    }, { passive: true });

    // Keyboard: ArrowLeft / ArrowRight move by 2%
    handle.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') {
        e.preventDefault();
        setPos(pos - 2);
      } else if (e.key === 'ArrowRight') {
        e.preventDefault();
        setPos(pos + 2);
      }
    });

    // Also allow dragging by clicking anywhere on the wrapper
    wrapper.addEventListener('mousedown', function (e) {
      if (e.target === handle || handle.contains(e.target)) return;
      setPos(posFromEvent(e));
      dragging = true;
      wrapper.classList.add('is-dragging');
    });

    // Init position
    setPos(50);
    // Keep hint visible initially; it will hide on first interaction
    // (hideHint is called by setPos on any real drag)
    if (hint) hint.classList.remove('is-hidden');
  }

  function boot() {
    document.querySelectorAll('.ba-wrapper[data-ba-id]').forEach(function (wrapper) {
      initSlider(wrapper);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Re-init on Shopify theme editor section load
  document.addEventListener('shopify:section:load', function (e) {
    var wrapper = e.target.querySelector('.ba-wrapper[data-ba-id]');
    if (wrapper) initSlider(wrapper);
  });

})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
document.querySelectorAll('[data-bundle-remove]').forEach(function(btn) {
  btn.addEventListener('click', async function() {
    var keys = this.dataset.bundleKeys.split(',').filter(Boolean);
    if (!keys.length) return;
    this.disabled = true;
    this.textContent = '...';
    var updates = {};
    keys.forEach(function(k) { updates[k] = 0; });
    try {
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: updates })
      });
    } finally {
      window.location.reload();
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gallery-mosaic"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var sectionEl = document.querySelector('.gallery-mosaic');
    if (!sectionEl) return;

    var lightboxes = document.querySelectorAll('.gallery-lightbox');

    lightboxes.forEach(function (lightbox) {
      var sectionId = lightbox.dataset.section;
      var total = parseInt(lightbox.dataset.total, 10);
      var currentIndex = 0;

      var dataStore = document.getElementById('gallery-data-' + sectionId);
      var img = lightbox.querySelector('.gallery-lightbox__image');
      var titleEl = lightbox.querySelector('.gallery-lightbox__title');
      var mediumEl = lightbox.querySelector('.gallery-lightbox__medium');

      var touchStartX = 0;
      var touchEndX = 0;

      function getItem(index) {
        if (!dataStore) return null;
        return dataStore.querySelector('[data-item="' + index + '"]');
      }

      function loadSlide(index) {
        var item = getItem(index);
        if (!item) return;
        img.src = item.dataset.src;
        img.alt = item.dataset.title || '';
        titleEl.textContent = item.dataset.title || '';
        mediumEl.textContent = item.dataset.caption || '';
        currentIndex = index;
      }

      function openLightbox(index) {
        loadSlide(index);
        lightbox.hidden = false;
        document.body.style.overflow = 'hidden';
        lightbox.querySelector('.gallery-lightbox__close').focus();
      }

      function closeLightbox() {
        lightbox.hidden = true;
        document.body.style.overflow = '';
      }

      function prevSlide() {
        var prev = (currentIndex - 1 + total) % total;
        loadSlide(prev);
      }

      function nextSlide() {
        var next = (currentIndex + 1) % total;
        loadSlide(next);
      }

      // Open triggers
      var galleryGrid = document.getElementById('gallery-mosaic-' + sectionId);
      if (galleryGrid) {
        galleryGrid.addEventListener('click', function (e) {
          var btn = e.target.closest('[data-lightbox-open]');
          if (!btn) return;
          openLightbox(parseInt(btn.dataset.index, 10));
        });
      }

      // Close
      lightbox.addEventListener('click', function (e) {
        if (e.target.closest('[data-lightbox-close]')) {
          closeLightbox();
        }
      });

      // Prev / Next
      lightbox.querySelector('[data-lightbox-prev]').addEventListener('click', prevSlide);
      lightbox.querySelector('[data-lightbox-next]').addEventListener('click', nextSlide);

      // Keyboard
      document.addEventListener('keydown', function (e) {
        if (lightbox.hidden) return;
        if (e.key === 'Escape') closeLightbox();
        if (e.key === 'ArrowLeft') prevSlide();
        if (e.key === 'ArrowRight') nextSlide();
      });

      // Touch swipe
      lightbox.addEventListener('touchstart', function (e) {
        touchStartX = e.changedTouches[0].clientX;
      }, { passive: true });

      lightbox.addEventListener('touchend', function (e) {
        touchEndX = e.changedTouches[0].clientX;
        var delta = touchEndX - touchStartX;
        if (Math.abs(delta) > 50) {
          if (delta < 0) {
            nextSlide();
          } else {
            prevSlide();
          }
        }
      }, { passive: true });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    var header = document.getElementById('site-header');
    var btn    = document.getElementById('mobile-menu-btn');
    var menu   = document.getElementById('mobile-menu');

    /* ── Scroll: add .scrolled when past 40px */
    if (header) {
      function onScroll() {
        header.classList.toggle('scrolled', window.scrollY > 40);
      }
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }

    /* ── Mobile menu toggle */
    if (btn && menu) {
      function openMenu() {
        menu.classList.add('open');
        menu.setAttribute('aria-hidden', 'false');
        btn.setAttribute('aria-expanded', 'true');
        btn.classList.add('menu-open');
      }
      function closeMenu() {
        menu.classList.remove('open');
        menu.setAttribute('aria-hidden', 'true');
        btn.setAttribute('aria-expanded', 'false');
        btn.classList.remove('menu-open');
      }

      btn.addEventListener('click', function () {
        menu.classList.contains('open') ? closeMenu() : openMenu();
      });

      /* Close on Escape */
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && menu.classList.contains('open')) {
          closeMenu();
          btn.focus();
        }
      });

      /* Close when a link is tapped */
      menu.querySelectorAll('a').forEach(function (link) {
        link.addEventListener('click', closeMenu);
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-slider"] && !Shopify.designMode) return;
  try {
    

class HeroSlider {
  constructor(el) {
    this.el         = el;
    this.track      = el.querySelector('.hero-slider__track');
    this.slides     = Array.from(el.querySelectorAll('.hero-slider__slide'));
    this.dots       = Array.from(el.querySelectorAll('.hero-slider__dot'));
    this.arrows     = Array.from(el.querySelectorAll('.hero-slider__arrow'));
    this.progressBar = el.querySelector('.hero-slider__progress-bar');
    this.count      = this.slides.length;
    this.current    = 0;
    this.busy       = false;
    this.direction  = 1;
    this.autoplay   = el.dataset.autoplay === 'true';
    this.speed      = parseInt(el.dataset.autoplaySpeed, 10) || 5000;
    this.transition = el.dataset.transition || 'zoom-fade';
    this.timer      = null;

    if (this.count < 2) return;
    this._init();
  }

  _init() {
    // Arrows
    this.arrows.forEach(btn => {
      btn.addEventListener('click', () => {
        const fwd = btn.dataset.direction === 'next';
        this.direction = fwd ? 1 : -1;
        fwd ? this.next() : this.prev();
      });
    });

    // Dots
    this.dots.forEach((dot, i) => {
      dot.addEventListener('click', () => {
        this.direction = i > this.current ? 1 : -1;
        this.goTo(i);
      });
    });

    // Keyboard
    this.el.setAttribute('tabindex', '0');
    this.el.addEventListener('keydown', e => {
      if (e.key === 'ArrowLeft')  { e.preventDefault(); this.direction = -1; this.prev(); }
      if (e.key === 'ArrowRight') { e.preventDefault(); this.direction =  1; this.next(); }
    });

    // Touch swipe
    let sx = 0, sy = 0;
    this.el.addEventListener('touchstart', e => {
      sx = e.touches[0].clientX;
      sy = e.touches[0].clientY;
    }, { passive: true });
    this.el.addEventListener('touchend', e => {
      const dx = e.changedTouches[0].clientX - sx;
      const dy = e.changedTouches[0].clientY - sy;
      if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 44) {
        this.direction = dx < 0 ? 1 : -1;
        dx < 0 ? this.next() : this.prev();
      }
    }, { passive: true });

    // Pause on hover / focus
    this.el.addEventListener('mouseenter', () => this._pause());
    this.el.addEventListener('mouseleave', () => this._resume());
    this.el.addEventListener('focusin',    () => this._pause());
    this.el.addEventListener('focusout',   () => this._resume());

    // Start
    if (this.autoplay) this._startAutoplay();
    this._tickProgress();
  }

  goTo(index) {
    if (this.busy || index === this.current) return;

    const prev = this.current;
    const next = ((index % this.count) + this.count) % this.count;

    this.busy = true;

    const leaving = this.slides[prev];
    const entering = this.slides[next];

    // Set directional CSS offset for slide transition
    if (this.transition === 'slide') {
      this.el.style.setProperty('--hs-slide-offset', this.direction > 0 ? '100%' : '-100%');
      this.el.style.setProperty('--hs-leaving-offset', this.direction > 0 ? '-100%' : '100%');
    }

    // Deactivate leaving slide
    leaving.classList.remove('is-active');
    leaving.classList.add('is-leaving');
    leaving.setAttribute('aria-hidden', 'true');
    leaving.setAttribute('tabindex', '-1');

    // Activate entering slide
    entering.classList.add('is-active');
    entering.setAttribute('aria-hidden', 'false');
    entering.setAttribute('tabindex', '0');

    // Update dots
    this.dots.forEach((dot, i) => {
      dot.classList.toggle('is-active', i === next);
      dot.setAttribute('aria-selected', String(i === next));
    });

    this.current = next;

    const cleanupDelay = this.transition === 'slide' ? 800 : 950;
    setTimeout(() => {
      leaving.classList.remove('is-leaving');
      this.busy = false;
    }, cleanupDelay);

    this._resetProgress();
  }

  next() { this.goTo((this.current + 1) % this.count); }
  prev() { this.goTo((this.current - 1 + this.count) % this.count); }

  _startAutoplay() {
    this._stopAutoplay();
    this.timer = setInterval(() => { this.direction = 1; this.next(); }, this.speed);
  }
  _stopAutoplay() {
    clearInterval(this.timer);
    this.timer = null;
  }
  _pause()  { this._stopAutoplay(); if (this.progressBar) this.progressBar.classList.remove('is-running'); }
  _resume() { if (this.autoplay) { this._startAutoplay(); this._tickProgress(); } }

  _tickProgress() {
    if (!this.progressBar) return;
    this.progressBar.classList.remove('is-running');
    void this.progressBar.offsetWidth; // force reflow
    if (this.autoplay) this.progressBar.classList.add('is-running');
  }
  _resetProgress() {
    if (!this.progressBar) return;
    this.progressBar.classList.remove('is-running');
    void this.progressBar.offsetWidth;
    if (this.autoplay && this.timer) this.progressBar.classList.add('is-running');
  }
}

// Boot all sliders on page
function initHeroSliders() {
  document.querySelectorAll('.hero-slider[data-has-slider="true"]').forEach(el => new HeroSlider(el));
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initHeroSliders);
} else {
  initHeroSliders();
}

// Re-init on Shopify theme editor section load
document.addEventListener('shopify:section:load', e => {
  const el = e.target.querySelector('.hero-slider[data-has-slider="true"]');
  if (el) new HeroSlider(el);
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-thanks"] && !Shopify.designMode) return;
  try {
    
if (window.location.hash) {
  history.replaceState(null, '', window.location.pathname + window.location.search);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orbit-hero"] && !Shopify.designMode) return;
  try {
    

(function () {
  'use strict';

  /* Speed multipliers and rotation directions per ring index (inner → outer) */
  const SPEED_MULT = [1.3, 1.0, 0.75];
  const DIR_SIGN   = [1, -1, 1];

  class OrbitHero {
    constructor(el) {
      this.el   = el;
      this.pref = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.raf  = null;

      const raw       = parseFloat(el.dataset.speed)   || 3;
      this.baseSpeed  = raw * 0.028;
      this.orbitCount  = parseInt(el.dataset.orbits)    || 2;
      this.outerR      = parseInt(el.dataset.radius)    || 280;
      this.ringGap     = parseInt(el.dataset.ringGap)   || 80;
      this.faceCenter  = el.dataset.faceCenter === 'true';

      this.rings = this._buildRings(el);
      if (this.rings.length === 0) return;

      el._orbit = this;
      this._bind();

      if (this.pref) {
        this._staticLayout();
      } else {
        this._frame();
      }
    }

    _buildRings(el) {
      /* Create ring state objects */
      const rings = Array.from({ length: this.orbitCount }, (_, i) => {
        const mult = SPEED_MULT[i] ?? 0.6;
        const dir  = DIR_SIGN[i]  ?? 1;
        const spd  = this.baseSpeed * mult * dir;
        return {
          items:     [],
          angle:     (360 / this.orbitCount) * i,
          baseSpeed: this.baseSpeed * mult,
          speed:     spd,
          target:    spd,
          dir,
          hovered:   false,
        };
      });

      /* Distribute items round-robin across rings */
      Array.from(el.querySelectorAll('.orbit-hero__item')).forEach(item => {
        const ri   = parseInt(item.dataset.ring) || 0;
        const ring = rings[Math.min(ri, this.orbitCount - 1)];
        if (ring) ring.items.push(item);
      });

      /* Drop rings with no items */
      return rings.filter(r => r.items.length > 0);
    }

    /* Aspect ratio for elliptical orbit (1.0 = circle) */
    get aspectRatio() {
      const w = this.el.offsetWidth || window.innerWidth;
      if (w < 480) return 0.72;
      if (w < 768) return 0.88;
      return 1.0;
    }

    ringRadius(ringIdx) {
      const maxR = Math.min(this.outerR, (this.el.offsetWidth || window.innerWidth) * 0.44);
      const gap  = Math.min(this.ringGap, maxR / (this.rings.length + 1));
      /* ring 0 = innermost, last ring = outermost (maxR) */
      return maxR - (this.rings.length - 1 - ringIdx) * gap;
    }

    _bind() {
      this.rings.forEach(ring => {
        ring.items.forEach(item => {
          item.addEventListener('mouseenter', () => {
            ring.target  = 0;
            ring.hovered = true;
            item.classList.add('is-hovered');
          });
          item.addEventListener('mouseleave', () => {
            ring.target  = ring.baseSpeed * ring.dir;
            ring.hovered = false;
            item.classList.remove('is-hovered');
          });
        });
      });

      const burst = () => {
        if (this.pref) return;
        const anyHovered = this.rings.some(r => r.hovered);
        if (anyHovered) return;
        this.rings.forEach(ring => {
          ring.target = ring.baseSpeed * ring.dir * 5.5;
          setTimeout(() => {
            if (!ring.hovered) ring.target = ring.baseSpeed * ring.dir;
          }, 680);
        });
      };

      window.addEventListener('focus', burst);
      document.addEventListener('visibilitychange', () => {
        if (!document.hidden) burst();
      });
    }

    _staticLayout() {
      const ar = this.aspectRatio;
      this.rings.forEach((ring, ri) => {
        const r = this.ringRadius(ri);
        const n = ring.items.length;
        ring.items.forEach((item, i) => {
          const rad    = ((360 / n) * i * Math.PI) / 180;
          const x      = Math.cos(rad) * r;
          const y      = Math.sin(rad) * r * ar;
          const rotDeg = this._faceRot(rad, ar);
          item.style.transform = `translate(${x}px,${y}px) translate(-50%,-50%) rotate(${rotDeg}deg)`;
        });
      });
    }

    /* Rotation so item base points toward center (works for elliptical orbits) */
    _faceRot(rad, ar) {
      if (!this.faceCenter) return 0;
      return (Math.atan2(-Math.sin(rad) * ar, -Math.cos(rad)) - Math.PI / 2) * 180 / Math.PI;
    }

    _frame() {
      const ar = this.aspectRatio;

      this.rings.forEach((ring, ri) => {
        ring.speed  += (ring.target - ring.speed) * 0.055;
        ring.angle   = (ring.angle + ring.speed) % 360;

        const r = this.ringRadius(ri);
        const n = ring.items.length;

        ring.items.forEach((item, i) => {
          const rad    = (((360 / n) * i + ring.angle) * Math.PI) / 180;
          const x      = Math.cos(rad) * r;
          const y      = Math.sin(rad) * r * ar;
          const rotDeg = this._faceRot(rad, ar);

          item.style.transform = `translate(${x}px,${y}px) translate(-50%,-50%) rotate(${rotDeg}deg)`;
          item.style.zIndex    = String(Math.round(((y / (r * ar) + 1) / 2) * 5) + 1);
        });
      });

      this.raf = requestAnimationFrame(() => this._frame());
    }

    destroy() {
      if (this.raf) cancelAnimationFrame(this.raf);
      this.raf = null;
    }
  }

  function init() {
    document.querySelectorAll('.orbit-hero').forEach(el => {
      if (!el._orbit) new OrbitHero(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', e => {
    const el = e.target.querySelector('.orbit-hero');
    if (!el) return;
    if (el._orbit) el._orbit.destroy();
    new OrbitHero(el);
  });

  document.addEventListener('shopify:section:unload', e => {
    const el = e.target.querySelector('.orbit-hero');
    if (el && el._orbit) el._orbit.destroy();
  });
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["process-steps"] && !Shopify.designMode) return;
  try {
    

(function () {
  function initProcessSteps() {
    var steps = document.querySelectorAll('.process-step');
    if (!steps.length) return;

    var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (prefersReduced) {
      steps.forEach(function (step) {
        step.classList.add('is-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -60px 0px' }
    );

    steps.forEach(function (step) {
      observer.observe(step);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProcessSteps);
  } else {
    initProcessSteps();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target.querySelector('.process-step')) {
      initProcessSteps();
    }
  });
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-configurator"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root      = document.querySelector('.cfg-root');
  var viewerCol = document.querySelector('.cfg-viewer-col');
  if (!root || !viewerCol) return;

  var THRESHOLD = 30;
  var compact   = false;

  function setCompact(on) {
    if (on === compact) return;
    compact = on;
    root.classList.toggle('cfg-root--compact', on);
  }

  window.addEventListener('scroll', function () {
    if (window.innerWidth >= 1024) return;
    setCompact(window.scrollY > THRESHOLD);
  }, { passive: true });

  window.addEventListener('resize', function () {
    if (window.innerWidth >= 1024) setCompact(false);
  }, { passive: true });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    

(function () {
  var gallery  = document.getElementById('product-gallery');
  var lightbox = document.getElementById('product-lightbox');
  if (!gallery) return;

  var mainImg   = gallery.querySelector('.pg-main-img');
  var thumbs    = Array.from(gallery.querySelectorAll('.pg-thumb'));
  var lbImg     = lightbox && lightbox.querySelector('#lightbox-img');
  var lbCounter = lightbox && lightbox.querySelector('#lightbox-counter');
  var lbThumbs  = lightbox && Array.from(lightbox.querySelectorAll('.pg-lb-thumb'));

  var current   = 0;
  var count     = thumbs.length || 1;
  var lastFocus = null;

  // ── Build images array from thumbnails ──
  var images = thumbs.length
    ? thumbs.map(function (t) {
        return { src: t.dataset.src, large: t.dataset.large, alt: t.dataset.alt };
      })
    : mainImg
      ? [{ src: mainImg.src, large: mainImg.src, alt: mainImg.alt }]
      : [];

  if (lightbox) lightbox.dataset.count = count;

  // ── Helpers ──────────────────────────────
  function setMainImage(index, withFade) {
    if (!images[index]) return;
    current = index;

    function swap() {
      if (mainImg) {
        mainImg.src = images[index].src;
        mainImg.alt = images[index].alt;
        mainImg.classList.remove('is-fading');
      }
      thumbs.forEach(function (t, i) {
        t.classList.toggle('is-active', i === index);
        t.setAttribute('aria-pressed', String(i === index));
      });
    }

    if (withFade && mainImg) {
      mainImg.classList.add('is-fading');
      setTimeout(swap, 180);
    } else {
      swap();
    }
  }

  function setLightboxImage(index) {
    if (!lightbox || !images[index]) return;
    current = index;

    lbImg.classList.add('is-fading');
    setTimeout(function () {
      lbImg.src = images[index].large || images[index].src;
      lbImg.alt = images[index].alt;
      lbImg.onload = function () { lbImg.classList.remove('is-fading'); };
      if (lbCounter) {
        lbCounter.textContent = (index + 1) + ' / ' + count;
      }
      if (lbThumbs) {
        lbThumbs.forEach(function (t, i) {
          t.classList.toggle('is-active', i === index);
          // scroll active thumb into view
          if (i === index) {
            t.scrollIntoView({ inline: 'nearest', behavior: 'smooth', block: 'nearest' });
          }
        });
      }
    }, 180);
  }

  function openLightbox(index) {
    if (!lightbox) return;
    lastFocus = document.activeElement;
    current = index;
    lightbox.setAttribute('aria-hidden', 'false');
    lightbox.classList.add('is-open');
    document.body.style.overflow = 'hidden';

    lbImg.classList.remove('is-fading');
    lbImg.src = images[index].large || images[index].src;
    lbImg.alt = images[index].alt;
    if (lbCounter) lbCounter.textContent = (index + 1) + ' / ' + count;
    if (lbThumbs) {
      lbThumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === index); });
    }

    // Focus close button
    var closeBtn = lightbox.querySelector('[data-action="close"]');
    if (closeBtn) setTimeout(function () { closeBtn.focus(); }, 50);
  }

  function closeLightbox() {
    if (!lightbox) return;
    lightbox.classList.remove('is-open');
    lightbox.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (lastFocus) lastFocus.focus();
  }

  function nextImage() {
    var idx = (current + 1) % count;
    setMainImage(idx, true);
    if (lightbox && lightbox.classList.contains('is-open')) setLightboxImage(idx);
  }

  function prevImage() {
    var idx = (current - 1 + count) % count;
    setMainImage(idx, true);
    if (lightbox && lightbox.classList.contains('is-open')) setLightboxImage(idx);
  }

  // ── Gallery: thumbnail clicks ─────────────
  thumbs.forEach(function (t, i) {
    t.addEventListener('click', function () { setMainImage(i, true); });
  });

  // ── Gallery: arrow buttons ────────────────
  var prevBtn = gallery.querySelector('.pg-prev');
  var nextBtn = gallery.querySelector('.pg-next');
  if (prevBtn) prevBtn.addEventListener('click', function (e) { e.stopPropagation(); prevImage(); });
  if (nextBtn) nextBtn.addEventListener('click', function (e) { e.stopPropagation(); nextImage(); });

  // ── Gallery: expand (open lightbox) ──────
  var mainWrap = gallery.querySelector('.pg-main-wrap');
  if (mainWrap && lightbox) {
    mainWrap.addEventListener('click', function () { openLightbox(current); });
    mainWrap.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openLightbox(current); }
    });
  }

  // ── Gallery: swipe on main image ─────────
  if (mainWrap && count > 1) {
    var sx = 0;
    mainWrap.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
    mainWrap.addEventListener('touchend', function (e) {
      var dx = e.changedTouches[0].clientX - sx;
      if (Math.abs(dx) > 40) { dx < 0 ? nextImage() : prevImage(); }
    }, { passive: true });
  }

  // ── Lightbox: controls ────────────────────
  if (lightbox) {
    lightbox.addEventListener('click', function (e) {
      var action = e.target.closest('[data-action]');
      if (!action) return;
      var a = action.dataset.action;
      if (a === 'close') closeLightbox();
      if (a === 'prev')  { prevImage(); setLightboxImage(current); }
      if (a === 'next')  { nextImage(); setLightboxImage(current); }
    });

    // Lightbox thumbnails
    if (lbThumbs) {
      lbThumbs.forEach(function (t, i) {
        t.addEventListener('click', function () {
          setMainImage(i, false);
          setLightboxImage(i);
        });
      });
    }

    // Lightbox swipe
    var lbSx = 0;
    lightbox.addEventListener('touchstart', function (e) { lbSx = e.touches[0].clientX; }, { passive: true });
    lightbox.addEventListener('touchend', function (e) {
      var dx = e.changedTouches[0].clientX - lbSx;
      if (Math.abs(dx) > 44) {
        if (dx < 0) { nextImage(); setLightboxImage(current); }
        else        { prevImage(); setLightboxImage(current); }
      }
    }, { passive: true });
  }

  // ── Keyboard ──────────────────────────────
  document.addEventListener('keydown', function (e) {
    if (!lightbox || !lightbox.classList.contains('is-open')) return;
    if (e.key === 'Escape')     closeLightbox();
    if (e.key === 'ArrowRight') { e.preventDefault(); nextImage(); setLightboxImage(current); }
    if (e.key === 'ArrowLeft')  { e.preventDefault(); prevImage(); setLightboxImage(current); }
  });

  // ── Initial active thumb ──────────────────
  if (thumbs[0]) thumbs[0].classList.add('is-active');

})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stats-counter"] && !Shopify.designMode) return;
  try {
    

(function () {
  function easeOut(t) {
    return 1 - Math.pow(1 - t, 3);
  }

  function animateCount(el, target, duration) {
    var start = null;
    var startVal = 0;

    function step(timestamp) {
      if (!start) start = timestamp;
      var elapsed = timestamp - start;
      var progress = Math.min(elapsed / duration, 1);
      var current = Math.round(easeOut(progress) * (target - startVal) + startVal);

      el.textContent = current > 999 ? current.toLocaleString() : String(current);

      if (progress < 1) {
        requestAnimationFrame(step);
      } else {
        el.textContent = target > 999 ? target.toLocaleString() : String(target);
      }
    }

    requestAnimationFrame(step);
  }

  function initStatsCounter() {
    var sections = document.querySelectorAll('[data-stats-section]');
    if (!sections.length) return;

    var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    sections.forEach(function (section) {
      var counters = section.querySelectorAll('[data-count-target]');
      if (!counters.length) return;

      if (prefersReduced) {
        counters.forEach(function (el) {
          var target = parseInt(el.getAttribute('data-count-target'), 10);
          if (!isNaN(target)) {
            el.textContent = target > 999 ? target.toLocaleString() : String(target);
          }
        });
        return;
      }

      var triggered = false;

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting && !triggered) {
              triggered = true;
              observer.unobserve(entry.target);

              counters.forEach(function (el) {
                var target = parseInt(el.getAttribute('data-count-target'), 10);
                if (!isNaN(target)) {
                  animateCount(el, target, 1800);
                }
              });
            }
          });
        },
        { threshold: 0.25 }
      );

      observer.observe(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStatsCounter);
  } else {
    initStatsCounter();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target.querySelector('[data-stats-section]')) {
      initStatsCounter();
    }
  });
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["string-art-hero"] && !Shopify.designMode) return;
  try {
    

class StringArtHero {
  constructor(el) {
    this.el      = el;
    this.canvas  = el.querySelector('.sa-hero__canvas');
    this.ctx     = this.canvas.getContext('2d');
    this.fontRef = el.querySelector('.sa-hero__font-ref');

    this.text      = el.dataset.text || '';
    this.nailCount = parseInt(el.dataset.nailCount)   || 250;
    this.loop      = el.dataset.loop === 'true';
    this.canvasH   = parseInt(el.dataset.canvasHeight) || 220;

    this.sc      = el.dataset.stringColor || '#ffffff';
    this.so      = parseFloat(el.dataset.stringOpacity) || 0.85;
    this.colNail = this._rgba(el.dataset.nailColor || '#ffffff', 1.0);

    /* Speed → fraction of total fibers drawn per rAF frame */
    const sp = parseInt(el.dataset.speed) || 10;
    this.speedFactor = sp <= 2 ? 1 / 320 : sp >= 30 ? 1 / 40 : 1 / 130;

    this.nails       = [];
    this.fibers      = [];
    this.nailIdx     = 0;
    this.fiberIdx    = 0;
    this.unweaveIdx  = 0;
    this.fiberBatch  = 1;
    this.phase       = 'idle';
    this.raf         = null;
    this.loopTimer   = null;
    this._observer   = null;

    this._resizeHandler = this._debounce(this._onResize.bind(this), 280);
    window.addEventListener('resize', this._resizeHandler);
    document.fonts.ready.then(() => this._boot());
  }

  /* ── Boot ──────────────────────────────────────────── */
  _boot() {
    this._resize();
    const built = this._buildFibers();
    this.nails      = built.nails;
    this.fibers     = built.fibers;
    this.fiberBatch = Math.max(1, Math.ceil(this.fibers.length * this.speedFactor));
    if (built.trimH > 0) this._applyTrimH(built.trimH);
    this._setupObserver();
  }

  /* Start animation only when the section enters the viewport */
  _setupObserver() {
    if (!('IntersectionObserver' in window)) { this._startAnim(); return; }
    this._observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting && this.phase === 'idle') {
          this._startAnim();
          /* Disconnect — for loop mode the animation manages itself after first trigger */
          this._observer.disconnect();
          this._observer = null;
        }
      },
      { threshold: 0.15 }
    );
    this._observer.observe(this.el);
  }

  _resize() {
    const dpr = Math.min(window.devicePixelRatio || 1, 2);
    const w = this.el.offsetWidth;
    const h = this.canvasH;
    this.W = w; this.H = h;
    this.canvas.width  = w * dpr;
    this.canvas.height = h * dpr;
    this.canvas.style.width  = w + 'px';
    this.canvas.style.height = h + 'px';
    this.ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
  }

  /* Resize canvas (and wrapper) to the trimmed text height */
  _applyTrimH(h) {
    const dpr = Math.min(window.devicePixelRatio || 1, 2);
    this.H = h;
    this.canvas.width  = this.W * dpr;
    this.canvas.height = h * dpr;
    this.canvas.style.height = h + 'px';
    const wrap = this.canvas.parentElement;
    if (wrap) wrap.style.height = h + 'px';
    this.ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
  }

  /* ── Fiber filter ──────────────────────────────────────
     Instead of simulating nails + threads (which requires
     fragile clustering), this renders text to a mask and then
     "extends" short line segments from random text pixels along
     8 discrete angles until they leave the letter shape.
     The accumulated crossing lines produce the string-art look
     purely from the text geometry — no letter detection needed.
  ─────────────────────────────────────────────────────── */
  _buildFibers() {
    const { W, H } = this;
    if (!this.text || W < 10 || H < 10) return { nails: [], fibers: [] };

    /* 1 ── Render text to temp canvas ── */
    const temp = document.createElement('canvas');
    temp.width = W; temp.height = H;
    const tctx = temp.getContext('2d', { willReadFrequently: true });
    tctx.fillStyle = '#ffffff';
    tctx.fillRect(0, 0, W, H);

    let fontFamily = "Georgia, 'Times New Roman', serif";
    if (this.fontRef) {
      const ff = getComputedStyle(this.fontRef).fontFamily;
      if (ff) fontFamily = ff;
    }
    let fontSize = H * 0.80;
    tctx.font = `bold ${fontSize}px ${fontFamily}`;
    tctx.textAlign = 'center'; tctx.textBaseline = 'middle';
    const mw = tctx.measureText(this.text).width;
    if (mw > W * 0.96) {
      fontSize *= (W * 0.96) / mw;
      tctx.font = `bold ${fontSize}px ${fontFamily}`;
    }
    tctx.fillStyle = '#000000';
    tctx.fillText(this.text, W / 2, H / 2);

    const { data } = tctx.getImageData(0, 0, W, H);
    const THR = 80;

    /* Fast text-pixel lookup (no border expansion needed — fibers stay in text) */
    const inText = (x, y) => {
      const xi = Math.round(x), yi = Math.round(y);
      if (xi < 0 || xi >= W || yi < 0 || yi >= H) return false;
      return data[(yi * W + xi) * 4] < THR;
    };

    /* 2 ── Collect pixel pools ── */
    const textPx = [], edgePx = [];
    for (let y = 1; y < H - 1; y++) {
      for (let x = 1; x < W - 1; x++) {
        if (data[(y * W + x) * 4] >= THR) continue;
        textPx.push({ x, y });
        for (const [dx, dy] of [[-1,0],[1,0],[0,-1],[0,1]]) {
          if (data[((y+dy)*W+(x+dx))*4] >= THR) { edgePx.push({ x, y }); break; }
        }
      }
    }
    if (!textPx.length) return { nails: [], fibers: [], trimH: 0 };

    /* 3 ── Nail dots: sample from edge pixels ── */
    const nails = this._sample(edgePx, this.nailCount).map(({ x, y }) => ({
      x: x + (Math.random() - 0.5) * 2,
      y: y + (Math.random() - 0.5) * 2,
    }));

    /* 4 ── Fiber filter ──────────────────────────────────
       For each of ANGLE_COUNT equally-spaced directions,
       pick random text-pixel origins and extend a line segment
       in BOTH directions along that angle until the path
       leaves a text pixel. The fiber is kept only if the
       total span ≥ minLen px.

       Because the extension stops at the letter boundary,
       fibers are guaranteed to stay inside the letter shape
       with no clustering or validation required.
    ─────────────────────────────────────────────────────── */
    const ANGLE_COUNT  = 8;                      /* directions: 0°,22.5°,…,157.5° */
    const maxHalf      = H * 0.92;               /* max half-length per direction  */
    const minLen       = 4;                      /* reject very short fibers       */
    const totalFibers  = this.nailCount * 8;     /* ~2000 fibers for 250 nails     */
    const perAngle     = Math.ceil(totalFibers / ANGLE_COUNT);
    const fibers       = [];

    for (let ai = 0; ai < ANGLE_COUNT; ai++) {
      const angle = (ai / ANGLE_COUNT) * Math.PI;
      const cos   = Math.cos(angle);
      const sin   = Math.sin(angle);
      let   count = 0;
      let   tries = 0;

      while (count < perAngle && tries < perAngle * 5) {
        tries++;
        const p = textPx[Math.floor(Math.random() * textPx.length)];

        /* Extend forward (+) */
        let fwd = 0;
        for (let d = 1; d <= maxHalf; d++) {
          if (inText(p.x + cos * d, p.y + sin * d)) fwd = d; else break;
        }
        /* Extend backward (−) */
        let bwd = 0;
        for (let d = 1; d <= maxHalf; d++) {
          if (inText(p.x - cos * d, p.y - sin * d)) bwd = d; else break;
        }

        const len = fwd + bwd;
        if (len < minLen) continue;

        /* Longer fibers → more opaque (they span a full stroke) */
        const t     = Math.min(1, len / (H * 0.45));
        const alpha = (0.15 + t * 0.70) * this.so;

        fibers.push({
          x1: p.x - cos * bwd, y1: p.y - sin * bwd,
          x2: p.x + cos * fwd, y2: p.y + sin * fwd,
          alpha,
        });
        count++;
      }
    }

    /* Sort left → right for a natural "writing" reveal animation */
    fibers.sort((a, b) => Math.min(a.x1, a.x2) - Math.min(b.x1, b.x2));

    /* Pixel-trim: shrink canvas to actual text bounds + small padding */
    let minY = H, maxY = 0;
    for (const { y } of textPx) {
      if (y < minY) minY = y;
      if (y > maxY) maxY = y;
    }
    const PAD     = 5;
    const trimTop = Math.max(0, minY - PAD);
    const trimH   = Math.min(H, maxY + PAD) - trimTop;
    for (const n of nails)  { n.y -= trimTop; }
    for (const f of fibers) { f.y1 -= trimTop; f.y2 -= trimTop; }

    return { nails, fibers, trimH };
  }

  /* Stratified random sample */
  _sample(arr, n) {
    if (!arr.length) return [];
    n = Math.min(n, arr.length);
    const step = arr.length / n;
    const out  = [];
    for (let i = 0; i < n; i++) {
      const base = Math.floor(i * step);
      const j    = Math.floor(Math.random() * Math.max(1, step));
      out.push(arr[Math.min(base + j, arr.length - 1)]);
    }
    return out;
  }

  /* ── Animation ─────────────────────────────────────── */
  /* fromLoop = true: nails already visible, redraw them instantly to skip
     the blank-canvas flash that happens between clearRect and the rAF tick */
  _startAnim(fromLoop = false) {
    cancelAnimationFrame(this.raf);
    clearTimeout(this.loopTimer);
    const ctx = this.ctx;
    ctx.clearRect(0, 0, this.W, this.H);

    if (fromLoop && this.nails.length) {
      ctx.fillStyle = this.colNail;
      for (const { x, y } of this.nails) {
        ctx.beginPath();
        ctx.arc(x, y, 1.8, 0, Math.PI * 2);
        ctx.fill();
      }
      this.nailIdx = this.nails.length;
      this.phase   = 'fibers';
    } else {
      this.nailIdx = 0;
      this.phase   = 'nails';
    }
    this.fiberIdx   = 0;
    this.unweaveIdx = 0;
    this.raf = requestAnimationFrame(() => this._tick());
  }

  _tick() {
    const ctx = this.ctx;

    if (this.phase === 'nails') {
      const batch = Math.ceil(this.nails.length / 20);
      for (let k = 0; k < batch && this.nailIdx < this.nails.length; k++) {
        const { x, y } = this.nails[this.nailIdx++];
        ctx.beginPath();
        ctx.arc(x, y, 1.8, 0, Math.PI * 2);
        ctx.fillStyle = this.colNail;
        ctx.fill();
      }
      if (this.nailIdx >= this.nails.length) this.phase = 'fibers';
      this.raf = requestAnimationFrame(() => this._tick());

    } else if (this.phase === 'fibers') {
      ctx.lineWidth = 0.6;
      for (let k = 0; k < this.fiberBatch && this.fiberIdx < this.fibers.length; k++) {
        const { x1, y1, x2, y2, alpha } = this.fibers[this.fiberIdx++];
        ctx.beginPath();
        ctx.moveTo(x1, y1);
        ctx.lineTo(x2, y2);
        ctx.strokeStyle = this._rgba(this.sc, alpha);
        ctx.stroke();
      }
      if (this.fiberIdx >= this.fibers.length) {
        if (this.loop) {
          this.phase = 'wait';
          /* Pause 1.8 s fully drawn, then start un-weaving left→right */
          this.loopTimer = setTimeout(() => {
            this.unweaveIdx = 0;
            this.phase = 'unweave';
            this.raf = requestAnimationFrame(() => this._tick());
          }, 1800);
        }
        return;
      }
      this.raf = requestAnimationFrame(() => this._tick());

    } else if (this.phase === 'unweave') {
      /* Clear and redraw fibers[unweaveIdx..end] — erases left→right (start→end of word).
         Nails are redrawn each frame so they stay visible throughout. */
      ctx.clearRect(0, 0, this.W, this.H);

      ctx.fillStyle = this.colNail;
      for (let i = 0; i < this.nails.length; i++) {
        const { x, y } = this.nails[i];
        ctx.beginPath();
        ctx.arc(x, y, 1.8, 0, Math.PI * 2);
        ctx.fill();
      }

      ctx.lineWidth = 0.6;
      for (let i = this.unweaveIdx; i < this.fibers.length; i++) {
        const { x1, y1, x2, y2, alpha } = this.fibers[i];
        ctx.beginPath();
        ctx.moveTo(x1, y1);
        ctx.lineTo(x2, y2);
        ctx.strokeStyle = this._rgba(this.sc, alpha);
        ctx.stroke();
      }

      this.unweaveIdx += this.fiberBatch;
      if (this.unweaveIdx >= this.fibers.length) {
        /* Brief pause with only nails visible, then restart (nails drawn instantly) */
        this.loopTimer = setTimeout(() => this._startAnim(true), 350);
        return;
      }
      this.raf = requestAnimationFrame(() => this._tick());
    }
  }

  /* ── Helpers ───────────────────────────────────────── */
  _rgba(hex, alpha) {
    if (!hex || hex.length < 7) return `rgba(255,255,255,${alpha.toFixed(3)})`;
    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);
    return `rgba(${r},${g},${b},${alpha.toFixed(3)})`;
  }

  _debounce(fn, ms) {
    let t;
    return (...args) => { clearTimeout(t); t = setTimeout(() => fn(...args), ms); };
  }

  _onResize() {
    cancelAnimationFrame(this.raf);
    clearTimeout(this.loopTimer);
    this._resize();
    const built = this._buildFibers();
    this.nails      = built.nails;
    this.fibers     = built.fibers;
    this.fiberBatch = Math.max(1, Math.ceil(this.fibers.length * this.speedFactor));
    if (built.trimH > 0) this._applyTrimH(built.trimH);
    /* Only restart if animation was already triggered (not waiting for scroll) */
    if (this.phase !== 'idle') this._startAnim();
  }

  destroy() {
    cancelAnimationFrame(this.raf);
    clearTimeout(this.loopTimer);
    window.removeEventListener('resize', this._resizeHandler);
    if (this._observer) { this._observer.disconnect(); this._observer = null; }
  }
}

/* ── Bootstrap ─────────────────────────────────────────── */
function initSAHeroes() {
  document.querySelectorAll('[data-sa-section]').forEach(el => {
    if (!el._saHero) el._saHero = new StringArtHero(el);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initSAHeroes);
} else {
  initSAHeroes();
}

document.addEventListener('shopify:section:load', e => {
  const el = e.target.querySelector('[data-sa-section]');
  if (!el) return;
  if (el._saHero) el._saHero.destroy();
  el._saHero = new StringArtHero(el);
});

document.addEventListener('shopify:section:unload', e => {
  const el = e.target.querySelector('[data-sa-section]');
  if (el && el._saHero) { el._saHero.destroy(); delete el._saHero; }
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["timeline"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initTimeline(sectionEl) {
      var items = Array.from(sectionEl.querySelectorAll('.tl-item'));
      var connectors = Array.from(sectionEl.querySelectorAll('.tl-connector'));
      var staggerMs = 100;

      sectionEl.classList.add('is-animated');

      function animateIn() {
        items.forEach(function (item, i) {
          setTimeout(function () {
            item.classList.add('tl-item--visible');
          }, i * staggerMs);
        });
        connectors.forEach(function (connector, i) {
          setTimeout(function () {
            connector.classList.add('tl-connector--visible');
          }, (i + 1) * staggerMs + Math.floor(staggerMs / 2));
        });
      }

      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                animateIn();
                observer.unobserve(entry.target);
              }
            });
          },
          { threshold: 0.1 }
        );
        observer.observe(sectionEl);
      } else {
        animateIn();
      }
    }

    document.querySelectorAll('.tl-section').forEach(initTimeline);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-carousel"] && !Shopify.designMode) return;
  try {
    

(function () {
  'use strict';

  function initVideoCarousel(section) {
    var sectionId   = section.dataset.sectionId;
    var track       = section.querySelector('.video-carousel__track');
    var modal       = document.getElementById('vc-modal-' + sectionId);
    var iframe      = modal ? modal.querySelector('.vc-modal__iframe') : null;
    var closeEls    = modal ? modal.querySelectorAll('[data-close-modal]') : [];
    var autoplay    = section.dataset.autoplay === 'true';
    var prevBtn     = section.querySelector('.video-carousel__arrow--prev');
    var nextBtn     = section.querySelector('.video-carousel__arrow--next');
    var lastFocused = null;

    if (!track || !modal || !iframe) return;

    // ── Normalize any YouTube/Vimeo URL to embed URL ─
    function normalizeUrl(url) {
      if (!url) return url;
      // YouTube watch: youtube.com/watch?v=ID
      if (url.indexOf('youtube.com/watch') >= 0) {
        var vid = url.split('v=')[1];
        if (vid) vid = vid.split('&')[0];
        return 'https://www.youtube.com/embed/' + (vid || '');
      }
      // YouTube short: youtu.be/ID
      if (url.indexOf('youtu.be/') >= 0) {
        var vid = url.split('youtu.be/')[1];
        if (vid) vid = vid.split('?')[0];
        return 'https://www.youtube.com/embed/' + (vid || '');
      }
      // Vimeo watch: vimeo.com/ID (not player.vimeo.com)
      if (url.indexOf('vimeo.com/') >= 0 && url.indexOf('player.vimeo.com') < 0) {
        var vid = url.split('vimeo.com/')[1];
        if (vid) vid = vid.split('?')[0].split('#')[0];
        return 'https://player.vimeo.com/video/' + (vid || '');
      }
      return url;
    }

    // ── Open modal ───────────────────────────────────
    function openModal(videoUrl) {
      lastFocused = document.activeElement;
      var embedUrl = normalizeUrl(videoUrl);
      var src = autoplay
        ? embedUrl + (embedUrl.indexOf('?') >= 0 ? '&' : '?') + 'autoplay=1'
        : embedUrl;
      iframe.src = src;
      modal.setAttribute('aria-hidden', 'false');
      modal.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      // Focus close button for keyboard users
      var closeBtn = modal.querySelector('.vc-modal__close');
      if (closeBtn) closeBtn.focus();
    }

    // ── Close modal ──────────────────────────────────
    function closeModal() {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      iframe.src = '';
      document.body.style.overflow = '';
      if (lastFocused) lastFocused.focus();
    }

    // ── Play buttons ─────────────────────────────────
    track.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-video-url]');
      if (!btn) return;
      var url = btn.dataset.videoUrl;
      if (url) openModal(url);
    });

    // ── Modal close triggers ─────────────────────────
    closeEls.forEach(function (el) {
      el.addEventListener('click', closeModal);
    });

    // ── ESC key ──────────────────────────────────────
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) {
        closeModal();
      }
    });

    // ── Trap focus inside modal ──────────────────────
    modal.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      var focusable = Array.from(modal.querySelectorAll(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
      )).filter(function (el) { return !el.disabled; });
      if (!focusable.length) return;
      var first = focusable[0];
      var last  = focusable[focusable.length - 1];
      if (e.shiftKey) {
        if (document.activeElement === first) { e.preventDefault(); last.focus(); }
      } else {
        if (document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });

    // ── Arrow scroll ─────────────────────────────────
    function scrollByCard(direction) {
      var cardWidth = track.firstElementChild
        ? track.firstElementChild.offsetWidth + 20 /* gap */
        : track.offsetWidth;
      track.scrollBy({ left: direction * cardWidth, behavior: 'smooth' });
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { scrollByCard(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { scrollByCard(1); });
  }

  // ── Boot ─────────────────────────────────────────
  function init() {
    document.querySelectorAll('.video-carousel').forEach(function (section) {
      initVideoCarousel(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init on Shopify theme editor section load
  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('.video-carousel');
    if (section) initVideoCarousel(section);
  });

}());


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-hero"] && !Shopify.designMode) return;
  try {
    

(function () {
  'use strict';

  function initVideoHero(section) {
    var vidSource = section.dataset.vidSource;

    // iframes (YouTube/Vimeo) are self-managing — nothing to do
    if (vidSource === 'youtube' || vidSource === 'vimeo') return;

    var video = section.querySelector('.vh-video');
    if (!video) return;

    var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)');

    function applyMotionPref() {
      if (prefersReduced.matches) {
        video.pause();
        video.removeAttribute('autoplay');
      } else {
        video.setAttribute('autoplay', '');
        video.play().catch(function () {});
      }
    }

    applyMotionPref();
    if (prefersReduced.addEventListener) {
      prefersReduced.addEventListener('change', applyMotionPref);
    }

    // Lazy-load src from data attribute (mp4 only)
    if (vidSource === 'mp4') {
      var videoUrl = section.dataset.videoUrl;
      if (videoUrl) {
        var source = video.querySelector('source');
        if (source && !source.src) {
          source.src = videoUrl;
          video.load();
        }
      }
    }

    // Pause when scrolled out of view
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            if (!prefersReduced.matches) video.play().catch(function () {});
          } else {
            video.pause();
          }
        });
      }, { threshold: 0.1 });
      observer.observe(section);
    }
  }

  function boot() {
    document.querySelectorAll('.vh-section[data-section-id]').forEach(function (section) {
      initVideoHero(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('.vh-section[data-section-id]');
    if (section) initVideoHero(section);
  });

})();


  } catch(e) { console.error(e); }
})();
})();
